// extracted by mini-css-extract-plugin
export default {"root":"styles_root__NOEbe","gridContainer":"styles_gridContainer__Q9XgG","item":"styles_item__Dd8Ew","emptyWidget":"styles_emptyWidget__Z5706"};